import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { getCommonClassNameDefault } from '@skatteetaten/ds-core-utils';
import { S as StepListStep } from '../StepListStep.esm.js';
export { b as getStepListStepShouldAutoFocusWhenActiveDefault, g as getStepListStepTitleAsDefault, a as getStepListStepVariantDefault } from '../StepListStep.esm.js';
import 'react-i18next';
import '@skatteetaten/ds-buttons';
import '@skatteetaten/ds-content';
import '@skatteetaten/ds-icons';
import '@skatteetaten/ds-typography';
import './styles.css';


var styles = {
    "stepList": "StepList-module_stepList__8Y0Vz"
};

const StepList = /*#__PURE__*/ forwardRef(({ id, className = getCommonClassNameDefault(), lang, 'data-testid': dataTestId, children }, ref)=>{
    return /*#__PURE__*/ jsx("ol", {
        ref: ref,
        id: id,
        className: `${styles.stepList} ${className}`.trim(),
        lang: lang,
        "data-testid": dataTestId,
        children: children
    });
});
StepList.displayName = 'StepList';
StepList.Step = StepListStep;
StepList.Step.displayName = 'StepList.Step';

export { StepList };
